<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/75VUd1/tc-custom/9781453293058.jpg?1728935149090" alt="This image is the cover for the book Stillness in Bethlehem, The Gregor Demarkian Holiday Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stillness in Bethlehem, The Gregor Demarkian Holiday Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A Christmas controversy turns deadly for a tiny New England village in a mystery that offers “a sharp perspective on the nasty smugness of small towns” (<i>The New York Times</i>). </b><br/>  Bethlehem, Vermont, is a sleepy little town, distinguished from the neighboring hamlets by its Christmas pageant. The holiday spectacular dates back generations; as the village’s only tourist attraction, it brings in much of the money that keeps Bethlehem afloat. The festivities are held on publicly owned land, which might be a slight violation of the separation of church and state, but no one has ever complained until Tish Verek comes to town. Verek is a true-crime writer from New York, and not long after she kicks up a fuss about the pageant, she’s shot dead in an apparent hunting accident. Anyone in Bethlehem could have fired the fatal bullet, and it’s up to ex–FBI investigator Gregor Demarkian to decide which Christmas-obsessed villager is really a grinch in disguise.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Haddam
      </h2>
      
      <p class="authorDescription body article">Jane Haddam (1951&ndash;2019) was an American author of mysteries. Born Orania Papazoglou, she worked as a college professor and magazine editor before publishing her Edgar Award&ndash;nominated first novel, <I>Sweet, Savage Death</I>, in 1984. This mystery introduced Patience McKenna, a sleuthing scribe who would go on to appear in four more books, including <I>Wicked, Loving Murder</I> (1985) and <I>Rich, Radiant Slaughter</I> (1988).<BR /> &#160;<BR /><I>Not a Creature Was Stirring </I>(1990) introduced Haddam&rsquo;s best-known character, former FBI agent Gregor Demarkian. The series spans more than twenty novels, many of them holiday-themed, including <I>Murder Superior </I>(1993), <I>Fountain of Death</I> (1995), and <I>Wanting Sheila Dead</I> (2005). Haddam&rsquo;s later novels include <I>Blood in the Water</I> (2012) and <I>Hearts of Sand</I> (2013).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f84bf6a4